export const contentTableConfig = {
  title: '分类统计列表',
  propList: [
    {prop: 'usedBy', label: '业务员', minWidth: '80'},
    {prop: 'deptName', label: '所属部门', minWidth: '80'},
    {prop: 'groupName', label: '所属组', minWidth: '80'},
    {prop: 'classifyA', label: 'A类客户', minWidth: '80'},
    {prop: 'classifyB', label: 'B类客户', minWidth: '80'},
    {prop: 'classifyC', label: 'C类客户', minWidth: '80'},
    {prop: 'rate', label: '评定等级', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
